import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
    FormRowComponent,
    InstructionsComponent,
    InstructionsWithFieldsContainerComponent,
} from '@r1-compass-library/components';
import { DivisionBasicSettingsFormService } from '../division-basic-settings-form.service';

@Component({
    selector: 'r1-compass-app-expiry-process',
    imports: [
        InstructionsWithFieldsContainerComponent,
        InstructionsComponent,
        FormRowComponent,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
    ],
    template: `
        <r1-compass-lib-instructions-with-fields-container>
            <r1-compass-lib-instructions headerText="Expiry Process" instructions>
                Enter the value to be added to the Eloqua Program Feeders table as the Eloqua Site Name.
            </r1-compass-lib-instructions>
            <form formArea>
                <r1-compass-lib-form-row name="Eloqua Site Name">
                    <mat-form-field>
                        <mat-label>Eloqua Site Name</mat-label>
                        <input matInput [formControl]="formService.divisionBasicSettingsForm.controls.eloquaSiteName" />
                    </mat-form-field>
                </r1-compass-lib-form-row>
            </form>
        </r1-compass-lib-instructions-with-fields-container>
    `,
    styles: ``,
})
export class ExpiryProcessComponent {
    protected readonly formService = inject(DivisionBasicSettingsFormService);
}
